import { TableCell, TextFieldProps } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import {
  CasRHFCurrencyField,
  CasEntitySelectProps,
  CasRHFPercentField,
  CasRHFSelect,
} from 'src/compass/shared/components';

export enum AmountType {
  Percentage = 'Percentage',
  AmountPerTrade = 'AmountPerTrade',
}

const options = [
  { id: AmountType.Percentage, name: 'Percentage' },
  { id: AmountType.AmountPerTrade, name: '$/Trade' },
];

type Props = Omit<CasEntitySelectProps, 'name'> &
  Omit<TextFieldProps, 'name'> & {
    name: string;
  };

export default function AmountPerTradeOrPercent(props: Props) {
  const { name, ...otherProps } = props;

  const { control } = useFormContext();
  const selectedAmountType = useWatch({ control, name });

  // if we add more options, then we can easily add conditions in switch
  let fieldName = '';
  let Component;
  let label;

  switch (selectedAmountType) {
    case AmountType.Percentage:
      fieldName = name.replace('amountType', 'percentage');
      label = 'Percent';
      Component = CasRHFPercentField;
      break;
    case AmountType.AmountPerTrade:
      fieldName = name.replace('amountType', 'amountPerTrade');
      label = 'Amount';
      Component = CasRHFCurrencyField;
      break;
    default:
  }

  return (
    <>
      <TableCell>
        <CasRHFSelect {...otherProps} options={options} name={name} fullWidth={false} />
      </TableCell>
      <TableCell>
        {Component && (
          <Component
            {...otherProps}
            name={fieldName}
            label={otherProps.label ? label : ''}
            fullWidth={false}
          />
        )}
      </TableCell>
    </>
  );
}
